module.exports = __webpack_public_path__ + "static/media/IlotB_synthese_2.ba659eed.webp";